import { render, staticRenderFns } from "./CBProposalPremisesGeneralProtection.vue?vue&type=template&id=17368b4c"
import script from "./CBProposalPremisesGeneralProtection.vue?vue&type=script&lang=js"
export * from "./CBProposalPremisesGeneralProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports